import * as React from 'react';
import { observer } from 'mobx-react';
import { ServiceView } from '@estee/elc-service';
import { CONTENT_BLOCK } from '@estee/elc-service-view-names';

const { name: serviceName } = __serviceInfo__;

interface IVtoServiceView {
    isVtoFoundationEnabled?: boolean;
    isOverlayOpened: boolean;
    overlayNodeId?: number;
}

export const VtoFoundationContentBlock = observer(
    ({ isVtoFoundationEnabled, isOverlayOpened, overlayNodeId }: IVtoServiceView) => {
        if (!overlayNodeId || !isVtoFoundationEnabled || !isOverlayOpened) {
            return null;
        }

        return (
            <ServiceView
                name={CONTENT_BLOCK}
                config={{ nid: overlayNodeId }}
                serviceName={serviceName}
            />
        );
    }
);
